/*
 * ROCANIIRU customization
 * File: assets/rc-journal-menu.js
 * Version: v1.0.1
 * Date: 2026-06-30
 *
 * Switches mega-c's Journal category, item list, and thumbnail image.
 */

if (!customElements.get('rc-journal-menu')) {
  customElements.define(
    'rc-journal-menu',
    class RcJournalMenu extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) {
          return;
        }

        this.isInitialized = true;
        this.categories = Array.from(this.querySelectorAll('[data-rc-mega-c-category]'));
        this.itemPanels = Array.from(this.querySelectorAll('[data-rc-mega-c-item-panel]'));
        this.itemLinks = Array.from(this.querySelectorAll('[data-rc-mega-c-media]'));
        this.mediaTemplates = Array.from(this.querySelectorAll('[data-rc-mega-c-media-template]'));
        this.mediaStage = this.querySelector('[data-rc-mega-c-media-stage]');

        this.categories.forEach((category) => {
          const activate = () => this.activateCategory(category.dataset.rcMegaCCategory, true);

          category.addEventListener('mouseenter', activate);
          category.addEventListener('focus', activate);
        });

        this.itemLinks.forEach((itemLink) => {
          const activate = () => {
            this.activateCategory(itemLink.dataset.rcMegaCParentCategory, false);
            this.showMedia(itemLink.dataset.rcMegaCMedia);
          };

          itemLink.addEventListener('mouseenter', activate);
          itemLink.addEventListener('focus', activate);
        });

        this.activateCategory(this.dataset.initialCategory || this.categories[0]?.dataset.rcMegaCCategory, true);
      }

      activateCategory(categoryId, resetMedia) {
        if (!categoryId) {
          return;
        }

        this.categories.forEach((category) => {
          const isActive = category.dataset.rcMegaCCategory === categoryId;
          category.classList.toggle('is-active', isActive);
          category.setAttribute('aria-expanded', String(isActive));
        });

        this.itemPanels.forEach((panel) => {
          panel.hidden = panel.dataset.rcMegaCItemPanel !== categoryId;
        });

        const panel = this.getItemPanel(categoryId);
        this.dataset.activeLayout = panel?.dataset.layout || 'wide-media';

        if (resetMedia) {
          this.showMedia(panel?.dataset.defaultMediaTemplate);
        }
      }

      showMedia(templateId) {
        if (!this.mediaStage) {
          return;
        }

        this.itemLinks.forEach((itemLink) => {
          itemLink.classList.toggle('is-active', itemLink.dataset.rcMegaCMedia === templateId);
        });

        const template = this.mediaTemplates.find((item) => item.dataset.rcMegaCMediaTemplate === templateId);

        this.mediaStage.classList.remove('is-image-visible');

        if (!template) {
          this.mediaStage.replaceChildren();
          this.mediaStage.dataset.activeTemplate = '';
          return;
        }

        this.mediaStage.replaceChildren(template.content.cloneNode(true));
        this.mediaStage.dataset.activeTemplate = templateId;

        const image = this.mediaStage.querySelector('.mega-menu-c__media-image');

        if (!image || image.complete) {
          window.requestAnimationFrame(() => this.revealImage(templateId));
          return;
        }

        const reveal = () => this.revealImage(templateId);

        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', reveal, { once: true });
      }

      revealImage(templateId) {
        if (this.mediaStage?.dataset.activeTemplate === templateId) {
          this.mediaStage.classList.add('is-image-visible');
        }
      }

      getItemPanel(categoryId) {
        return this.itemPanels.find((panel) => panel.dataset.rcMegaCItemPanel === categoryId);
      }
    }
  );
}
